import { get, post } from '../ReaderlyHttpClient';
import { ImageData } from './Data';

export enum MerchandiseCategory {
  Bookmark = 'Bookmark',
  Case = 'Case',
  Other = 'Other',
}

export const merchandiseCategoryLabels: Record<MerchandiseCategory, string> = {
  [MerchandiseCategory.Bookmark]: 'Закладки',
  [MerchandiseCategory.Case]: 'Чохли',
  [MerchandiseCategory.Other]: 'Інше',
};

export interface Merchandise {
  id: number;
  name: string;
  description?: string | null;
  details?: string | null;
  category: MerchandiseCategory;
  stockCount: number;
  price: number;
  priceType: string;
  isDeleted: boolean;
  primaryImage?: ImageData | null;
  images: ImageData[];
}

export interface MerchandisePage {
  totalCount: number;
  items: Merchandise[];
}

export const getShopItems = (search = '', index = 0, count = 50, suppressGlobalError = false) => {
  return get<MerchandisePage>('/merchandise', { search: search || undefined, index, count }, { suppressGlobalError });
};

export const getShopItem = (id: number) => {
  return get<Merchandise>(`/merchandise/${id}`, undefined, { suppressGlobalError: true });
};

export interface ShopInquiryRequest {
  name: string;
  phone: string;
  message?: string;
}

export const createShopInquiry = (itemId: number, request: ShopInquiryRequest) => {
  return post<void, ShopInquiryRequest>(`/merchandise/${itemId}/inquiries`, request, undefined, {
    suppressGlobalError: true,
  });
};